import React, { useState } from "react";
import { useLocation } from "react-router-dom";
import DetailPage from "../../../article/pages/details";
import ButtonLoader from "../../../../components/ButtonLoader";
import GetAITokens from "./components/GetAITokens";

function useQuery() {
    return new URLSearchParams(useLocation().search);
}

export default function AITokens() {
    const phoneId = useQuery().get("phoneId") || null;
    const licenceKey = useQuery().get("licenceKey") || null;
    const mentorId = useQuery().get("mentorId") || null;

    const [isLoading, setIsLoading] = useState(false);
    const [agreeTerms, setAgreeTerms] = useState(false);
    const [guestEmail, setGuestEmail] = useState(null);

    const handleSubmit = (e) => {
        e.preventDefault();
        setIsLoading(true);

        const checkbox = document.getElementById("agreeTerms");
        if (!checkbox.checked) {
            setAgreeTerms(false);
            setIsLoading(false);
            return;
        }

        if (guestEmail && guestEmail !== "") {
            setAgreeTerms(true);
        }

        setIsLoading(false);
    };

    return (
        <>
            {(!phoneId || phoneId === "") && (
                <div className="container-fluid" key={`ai-tokens`}>
                    <div className="row justify-content-center align-items-center" style={{ height: "80vh" }}>
                        <div className="col-auto text-center">
                            <div className="alert alert-warning mb-3" role="alert">
                                <i className="fas fa-exclamation-triangle me-2"></i>
                                Phone ID is required to buy AI Tokens.
                            </div>
                            <p className="text-muted">Please provide a valid phone ID to proceed.</p>
                        </div>
                    </div>
                </div>
            )}

            {phoneId && phoneId !== "" && (
                <>
                    {(!agreeTerms || (guestEmail && guestEmail === "")) && (
                        <>
                            <DetailPage slugI={"ai-tokens-terms"} />

                            <div className="container-fluid" key={`ai-tokens-join`}>
                                <div className="row">
                                    <div className="col-12">
                                        <div className="justify-content-between align-items-center">
                                            <div className="d-flex justify-content-center">
                                                <div className="col-lg-8 col-12 card custom-card p-4">
                                                    <form className="p-4 rounded shadow-sm" onSubmit={handleSubmit}>
                                                        <div className="mb-3">
                                                            <label htmlFor="guestEmail" className="form-label fw-semibold">Email Address</label>
                                                            <input
                                                                type="email"
                                                                className="form-control"
                                                                id="guestEmail"
                                                                placeholder="Enter your email"
                                                                value={guestEmail || ""}
                                                                onChange={(e) => setGuestEmail(e.target.value)}
                                                                required
                                                            />
                                                        </div>

                                                        <div className="mb-3">
                                                            <input
                                                                type="checkbox"
                                                                className="form-check-input"
                                                                id="agreeTerms"
                                                                required
                                                            />
                                                            <label className="form-check-label" htmlFor="agreeTerms">
                                                                I agree to the terms and conditions
                                                            </label>
                                                        </div>

                                                        <div className="d-grid">
                                                            <button
                                                                type="submit"
                                                                className="btn btn-primary"
                                                                disabled={isLoading}
                                                            >
                                                                {isLoading ? (
                                                                    <ButtonLoader />
                                                                ) : (
                                                                    <>
                                                                        <i className="fas fa-bolt me-2"></i>
                                                                        Buy AI Tokens
                                                                    </>
                                                                )}
                                                            </button>
                                                        </div>
                                                    </form>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </>
                    )}

                    {agreeTerms && guestEmail && (
                        <GetAITokens
                            guestEmail={guestEmail}
                            phoneId={phoneId}
                            licenceKey={licenceKey}
                            mentorId={mentorId}
                        />
                    )}
                </>
            )}
        </>
    );
}
